import { ListboxOptionLabel } from './ListboxOptionLabel';

// TODO: in v9, move styled() from ListboxOptionLabel.jsx to here
export var StyledListboxOptionLabel = ListboxOptionLabel;